import { CASINO_GAME_PROVIDERS_SEARCH_TYPES, initStore } from '../../../common';
import { actions } from './actions';

export const gameProvidersStore = (): void => {
	const initialState = {
		slice: 'CASINO_GAME_PROVIDERS',
		gameProviders: [],
		gamesLoading: false,
		savingData: false,
		pagesTotal: 1,
		currentPage: 1,
		rows: [],
		bulkRows: [],
		columns: [],
		perPage: '10',
		// active: [
		// 	{ value: '0', label: 'Disabled', isChecked: false },
		// 	{ value: '1', label: 'Enabled', isChecked: false },
		// ],
		filtering: false,
		filters: [{ name: 'searchType', value: CASINO_GAME_PROVIDERS_SEARCH_TYPES[0].value }],
		globalErrors: [],
		selectedGameProvider: null,
		gameProviderForm: {
			game_provider_id: '',
			game_provider_name: '',
			provider_url_live_desktop: '',
			provider_url_test_desktop: '',
			provider_url_live_mobile: '',
			provider_url_test_mobile: '',
			history_url_live: '',
			history_url_test: '',
			active: 1,
		},
		gameProviderPartnerForm: {
			short_name_test: '',
			short_name_live: '',
			selectedPartner: [],
		},
		formErrors: null,
		globalSuccess: '',
		allSkins: [],
		partners: [],
		activePartner: [],
		selectedProvider: null,
	};

	initStore(actions, initialState);
};
